<div class="divContent">
      <form
        [formGroup]="estudioMedicoPacienteForm"
        (submit)="guardarEstudioMedicoPaciente(estudioMedicoPacienteForm.value)"
        class="formCard"
      >
        <div class="card">
          <div class="formGroup">
            <input hidden matInput formControlName="id" />
          </div>
          <div class="formGroup">
            <input hidden matInput formControlName="idPaciente" />
          </div>
          <div class="validPaciente">
            <span
              class="advertenciaMensaje"
              *ngIf="paciente && !paciente?.email"
            >
              <mat-icon class="advertenciaIcono">report_problem</mat-icon>El
              paciente actual no tiene email, no le llegaran notificaciones que
              pueden ser importantes
            </span>
          </div>
          <div
            #selecEstMed
            class="formGroup selecEstMed"
            [class.medicoSection]="medicoSection"
          >
            <mat-form-field
              appearance="fill"
              class="example-full-width input estMed"
            >
              <mat-label>Estudio médico</mat-label>
              <mat-select *ngIf="!primEstudio"></mat-select>
              <mat-select
                *ngIf="primEstudio"
                formControlName="estudioMedico"
                [placeholder]="'Estudio médico'"
              >
                <mat-option>
                  <ngx-mat-select-search
                    id="estudioMedico"
                    [noEntriesFoundLabel]="'Not found'"
                    [placeholderLabel]="'Buscador'"
                    [formControl]="estudioMedico"
                    name="filterPost"
                    (ngModelChange)="filtrarEstudioMedico($event)"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let element of filtroEstudioMedico"
                  [value]="element.id"
                >
                  <span>{{ element.texto }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="divAgregar" *ngIf="!medicoSection">
              <button
                type="button"
                mat-mini-fab
                (click)="agregarEstudioMedico()"
                class="agregar"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
            <div class="validSelectAdd">
              <span
                style="color: rgb(236, 75, 72)"
                *ngIf="
                  estudioMedicoPacienteForm.get('estudioMedico').errors
                    ?.required &&
                  estudioMedicoPacienteForm.get('estudioMedico').touched
                "
              >
                El estudio médico es requerido
              </span>
            </div>
          </div>
          <div class="formGroup selecMed" *ngIf="!medicoSection">
            <mat-form-field
              appearance="fill"
              class="example-full-width input medico"
            >
              <mat-label>Médico</mat-label>
              <mat-select *ngIf="!primMedico"></mat-select>
              <mat-select
                *ngIf="primMedico"
                formControlName="medico"
                [placeholder]="'Médico'"
                (ngModelChange)="validarMedicoEmail($event)"
              >
                <mat-option>
                  <ngx-mat-select-search
                    id="medico"
                    [noEntriesFoundLabel]="'Not found'"
                    [placeholderLabel]="'Buscador'"
                    [formControl]="medico"
                    name="filterPost"
                    (ngModelChange)="filtrarMedico($event)"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option
                  class="opcion"
                  *ngFor="let element of filtroMedicos"
                  [value]="element.id"
                >
                  <div class="optionCM">
                    <span>{{ element.nombreCompleto }}</span>
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="divAgregar" style="display: none">
              <button
                type="button"
                mat-mini-fab
                (click)="agregarMedico()"
                class="agregar"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
            <div class="validSelectAdd">
              <span
                class="advertenciaMensaje"
                *ngIf="medicoSelecionado && !medicoSelecionado?.email"
              >
                <mat-icon class="advertenciaIcono">report_problem</mat-icon> El
                médico selecionado no tiene email, no le llegaran notificaciones
                que pueden ser importantes
              </span>
              <span
                style="color: rgb(236, 75, 72)"
                *ngIf="
                  estudioMedicoPacienteForm.get('medico').errors?.required &&
                  estudioMedicoPacienteForm.get('medico').touched
                "
              >
                El médico es requerido
              </span>
            </div>
          </div>
          <div class="formGroup" *ngIf="!esGrafico">
            <mat-form-field class="formFile">
              <div class="myfilebrowser">
                <mat-toolbar>
                  <input
                    matInput
                    [(ngModel)]="myfilename"
                    readonly
                    formControlName="memberContactNo"
                  />
                  <button mat-raised-button class="fileButton" color="primary">
                    Agregar
                  </button>
                </mat-toolbar>
                <input
                  type="file"
                  #fileUpload
                  id="fileUpload"
                  (change)="fileChangeEvent($event)"
                  name="fileUpload"
                  multiple
                  accept="*"
                />
              </div>
            </mat-form-field>
          </div>
          <div class="imagenesArray" *ngIf="!esGrafico">
            <mat-card
              class="cartaImagenes mat-elevation-z3"
              *ngFor="let imagen of listFile; let i = index"
            >
              <div class="imagenesAgregadas" *ngIf="!imagen.name">
                {{ imagen.descripcion ? imagen.descripcion : imagen.nombre }}
                <div class="divIconsMul">
                  <div
                    *ngIf="
                      supportedFileTypes.includes(
                        imagen?.nombre?.split('.').pop().toLowerCase()
                      )
                    "
                    class="divIcon ver"
                    (click)="mostrarImagen(imagen)"
                  >
                    <mat-icon class="icon">visibility</mat-icon>
                  </div>
                  <div
                    class="divIcon download"
                    *ngIf="imagen.nombre.slice(-4) == 'xlsx'"
                    (click)="descargarExcel(imagen)"
                  >
                    <mat-icon class="icon">download</mat-icon>
                  </div>
                  <div
                    class="divIcon download"
                    *ngIf="imagen.nombre.slice(-3) == 'pdf'"
                    (click)="descargarPdf(imagen)"
                  >
                    <mat-icon class="icon">download</mat-icon>
                  </div>
                  <div
                    class="divIcon download"
                    *ngIf="
                      imagen.nombre.slice(-4) != 'xlsx' &&
                      imagen.nombre.slice(-3) != 'pdf'
                    "
                    (click)="descargarImage(imagen)"
                  >
                    <mat-icon class="icon">download</mat-icon>
                  </div>
                  <div class="divIcon borrar" (click)="borrarImagen(i)">
                    <mat-icon class="icon">delete_forever</mat-icon>
                  </div>
                  <!--<mat-icon class="borrarImagen" (click)="borrarArchivo(imagen.id)">delete_forever</mat-icon>-->
                </div>
              </div>
              <div class="imagenesAgregadas" *ngIf="imagen.name">
                <div class="nombreImagen">
                  <span><b>Nombre del archivo:</b> {{ imagen.name }}</span>

                  <div>
                    <mat-form-field class="formFile" appearance="fill">
                      <input
                        (input)="descriptionChangeEvent($event, i)"
                        matInput
                        placeholder="Agregar descripción (opcional)"
                        name="descripcion"
                        id="descripcion"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div class="divIcons">
                  <div
                    *ngIf="
                      supportedFileTypes.includes(
                        imagen?.name?.split('.').pop().toLowerCase()
                      )
                    "
                    class="divIcon ver"
                    (click)="mostrarImagen(imagen)"
                  >
                    <mat-icon class="icon">visibility</mat-icon>
                  </div>
                  <div class="divIcon borrar" (click)="borrarImagen(i)">
                    <mat-icon class="icon">delete_forever</mat-icon>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>
          <div class="formGroup">
            <mat-form-field appearance="fill" class="input">
              <mat-label>Fecha</mat-label>
              <input
                formControlName="fecha"
                s
                matInput
                [matDatepicker]="picker"
                disabled
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker disabled="false"></mat-datepicker>
            </mat-form-field>
            <div class="valid">
              <span
                style="color: rgb(236, 75, 72)"
                *ngIf="
                  estudioMedicoPacienteForm.get('fecha').errors?.required &&
                  estudioMedicoPacienteForm.get('fecha').touched
                "
              >
                La fecha es requerida
              </span>
            </div>
          </div>
          <div class="formGroup selecCenMed">
            <mat-form-field appearance="fill" class="example-full-width input">
              <mat-label>Centro médico</mat-label>
              <mat-select *ngIf="!primCentro"></mat-select>
              <mat-select
                *ngIf="primCentro"
                formControlName="centroMedico"
                [placeholder]="'Centro médico'"
              >
                <mat-option>
                  <ngx-mat-select-search
                    id="centroMedico"
                    [noEntriesFoundLabel]="'Not found'"
                    [placeholderLabel]="'Buscador'"
                    [formControl]="centroMedico"
                    name="filterPost"
                    (ngModelChange)="filtrarCentroMedico($event)"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let element of filtroCentrosMedicos"
                  [value]="element.id"
                >
                  <div class="optionCM">
                    <div class="nombreSelect">{{ element.nombre }}</div>
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="valid">
              <span
                style="color: rgb(236, 75, 72)"
                *ngIf="
                  estudioMedicoPacienteForm.get('centroMedico').errors
                    ?.required &&
                  estudioMedicoPacienteForm.get('centroMedico').touched
                "
              >
                El centro médico es requerido
              </span>
            </div>
          </div>
          <div class="formGroup selecCenMed" *ngIf="!editar && !esGrafico">
            <mat-form-field appearance="fill" class="example-full-width input">
              <mat-label>Plantilla de Estudio Medico</mat-label>
              <mat-select *ngIf="!primCentro"></mat-select>

              <mat-select
                *ngIf="primCentro"
                formControlName="plantilla"
                [placeholder]="'Plantillas'"
              >
                <mat-option
                  *ngFor="let element of listaPlantillasEstudioMedico"
                  [value]="element.id"
                >
                  <div class="optionCM">
                    <div class="nombreSelect">{{ element.name }}</div>
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="formGroup" *ngIf="esOdontograma && !editar">
            <app-crear-odontograma
              [pacienteId]="paciente?.id"
              [medicoId]="estudioMedicoPacienteForm.get('medico').value"
              [centroMedicoId]="estudioMedicoPacienteForm.get('centroMedico').value"
              [fecha]="estudioMedicoPacienteForm.get('fecha').value"
              [observaciones]="estudioMedicoPacienteForm.get('observaciones').value"
              [fechaNacimiento]="paciente?.fechaNacimiento"
              [mostrarGuardar]="false"
              (odontogramaCreado)="onOdontogramaCreado()"
            ></app-crear-odontograma>
          </div>

          <div class="formGroup" *ngIf="esPeriodontograma && !editar">
            <app-crear-periodontograma
              [pacienteId]="paciente?.id"
              [medicoId]="estudioMedicoPacienteForm.get('medico').value"
              [centroMedicoId]="estudioMedicoPacienteForm.get('centroMedico').value"
              [fecha]="estudioMedicoPacienteForm.get('fecha').value"
              [observaciones]="estudioMedicoPacienteForm.get('observaciones').value"
              [fechaNacimiento]="paciente?.fechaNacimiento"
              [mostrarGuardar]="false"
              (periodontogramaCreado)="onPeriodontogramaCreado()"
            ></app-crear-periodontograma>
          </div>

          <div class="formGroup">
            <editor [init]="init" formControlName="observaciones"></editor>
          </div>

          <div class="formButton">
            <button
              *ngIf="editar"
              mat-raised-button
              class="buttonForm Cancelar"
              (click)="backClicked($event)"
            >
              Cancelar
            </button>
            <button
              *ngIf="editar"
              (click)="limpiarInputArchivo()"
              mat-raised-button
              class="buttonForm"
            >
              Editar
            </button>
            <button
              *ngIf="!editar"
              (click)="limpiarInputArchivo()"
              mat-raised-button
              class="buttonForm"
            >
              Crear
            </button>
          </div>
        </div>
      </form>
</div>
